import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Button, Card, CardBody, Col, Row } from "reactstrap"
import { AvField, AvForm } from "availity-reactstrap-validation"
import { useDispatch, useSelector } from "react-redux"
import {
  clearCategoriesDetails,
  createCategories,
  updateCategories,
} from "store/actions"
import { useParams } from "react-router-dom"
import UseImageUploader from "components/imageUploader/useImageUploader"
import { useLocation } from "react-router-dom"
import { useHistory } from "react-router-dom"

function Form({ updateData }) {
  const dispatch = useDispatch()
  const location = useLocation()
  const params = useParams()
  const history = useHistory()

  const { categoriesDetails } = useSelector(state => ({
    categoriesDetails: state.Categories?.categoriesDetails,
  }))

  useEffect(() => {
    if (location?.state === "create") {
      dispatch(clearCategoriesDetails())
    }
  }, [location?.state, dispatch])

  const [webBanners, setWebBanners] = useState([])
  const [appBanners, setAppBanners] = useState([])
  const [logoImages, setLogoImages] = useState([])

  useEffect(() => {
    if (categoriesDetails) {
      setLogoImages(categoriesDetails?.logoImages || [])
      setAppBanners(categoriesDetails?.appBanners || [])
      setWebBanners(categoriesDetails?.webBanners || [])
    }
  }, [categoriesDetails])

  const handleSubmit = (e, values) => {
    const categoryData = {
      ...values,
      ...(values?.priority !== undefined && values?.priority !== ""
        ? { priority: Number(values.priority) }
        : {}),
      name: values.name,
      description: values.description,
      webBanners: webBanners,
      appBanners: appBanners,
      logoImages: logoImages,
    }
    if (params?.id) {
      dispatch(updateCategories(categoryData, categoriesDetails?._id, history))
    } else {
      dispatch(createCategories(categoryData, history))
    }
  }

  return (
    <div>
      <AvForm
        onValidSubmit={(e, v) => {
          handleSubmit(e, v)
        }}
      >
        <Row>
          <>
            <Col sm="12">
              <Card>
                <CardBody>
                  <Row>
                    <Col
                      md={6}
                      style={{
                        marginTop: "10px",
                      }}
                    >
                      <Col className="px-2" md={4}>
                        <AvField
                          name="priority"
                          type="number"
                          className="form-control"
                          label="Priority"
                          value={categoriesDetails?.priority ?? ""}
                          validate={{
                            pattern: {
                              value: "^[1-9]\\d*$",
                              errorMessage:
                                "Priority must be a positive number",
                            },
                          }}
                        />
                      </Col>
                      <div className=" d-flex align-items-end m-2 ">
                        <div className="w-100">
                          <label>
                            Name<span className="text-danger">*</span>
                          </label>
                          <AvField
                            name="name"
                            type="text"
                            className="form-control"
                            value={categoriesDetails?.name ?? ""}
                            validate={{
                              required: {
                                value: true,
                                errorMessage: "Please enter a name",
                              },
                            }}
                          />
                        </div>
                      </div>
                      <Col md={12} className="p-2 ">
                        <AvField
                          name="description"
                          type="textarea"
                          className="form-control"
                          label="Description"
                          value={categoriesDetails?.description ?? ""}
                          validate={{
                            required: {
                              value: false,
                              errorMessage: "Please enter a name",
                            },
                          }}
                          style={{ height: 120 }}
                        />
                      </Col>

                      <label className="mt-5">Logo</label>
                      <UseImageUploader
                        imageSize={4}
                        imagesPreview={logoImages}
                        setImagesPreview={setLogoImages}
                        uploadUrl={"/focusmotors"}
                        isMultiple
                      />

                      <label className="mt-5">Web Banner</label>
                      <UseImageUploader
                        imageSize={4}
                        imagesPreview={webBanners}
                        setImagesPreview={setWebBanners}
                        uploadUrl={"/focusmotors"}
                        isMultiple
                      />
                      <label className="mt-5">App Banner</label>
                      <UseImageUploader
                        imageSize={4}
                        imagesPreview={appBanners}
                        setImagesPreview={setAppBanners}
                        uploadUrl={"/focusmotors"}
                        isMultiple
                      />
                    </Col>
                  </Row>
                  <Col sm="create" className="px-3">
                    <div className="d-flex align-items-center justify-content-end py-2 mb-4">
                      <Button className="px-5" color="warning" type="submit">
                        {updateData ? "Update" : "Create"}
                      </Button>
                    </div>
                  </Col>
                </CardBody>
              </Card>
            </Col>
          </>
        </Row>
      </AvForm>
    </div>
  )
}

export default Form

Form.propTypes = {
  updateData: PropTypes.any,
}
